import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FaEye } from 'react-icons/fa';
import { ROLE_CODES, STATUS_MAP } from './enquiryConstants';

const HEADER_CELL_STYLE = { fontSize: '17px', fontWeight: 600 };
const BODY_CELL_STYLE = { fontSize: '15px', fontWeight: 500 };
const BODY_CELL_STYLE_LG = { fontSize: '17px', fontWeight: 500 };

const AssignButton = ({ label, onClick }) => (
  <button className="w-36 h-9 bg-[#004172] text-white rounded-full" onClick={onClick}>
    {label}
  </button>
);

AssignButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export const AllTabTable = ({
  data,
  roleCode,
  convertUTCToLocal,
  getStatusStyle,
  getStatusLabel,
  getConciergeStyle,
  renderTraumaStatus,
  getBillingStyle,
  getBillingStatusText,
  onView,
  onBillingView,
  onEnquiryLog,
  onAddService,
}) => (
  <TableContainer component={Paper} className="print-table" style={{ width: '100%', overflowX: 'scroll' }}>
    <Table>
      <TableHead>
        <TableRow>
          {[
            'Enquiry ID', 'Patient ID', 'Patient Name', 'Enquiry Date',
            'Eclinic Name', 'Eclinic Location', 'Email Id', 'Swasthya Mithra',
            'Role', 'Mobile Number', 'Communication Number',
            'Preferred Hospital & eClinic', 'Concierge Name', 'Concierge Status',
            'Status', 'Trauma', 'Reason For Hold', 'Reason For Reject',
            'Status Date', 'View Enquiry Details', 'Billing Count',
            'Enquiry Log', 'Camp', 'Feedback Rate', 'Feedback Notes',
            'Feedback Msg Status', 'Action',
          ].map((header) => (
            <TableCell key={header} style={HEADER_CELL_STYLE}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item) => (
          <TableRow key={item.id}>
            <TableCell style={BODY_CELL_STYLE_LG}>{item.id}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientId}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{convertUTCToLocal(item.createdDate)}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicLocationName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientEmail}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.swasthUserName || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.roleCode || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientContactNumber || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.communicationMobile || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.hospitalName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.conciergeName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <span style={getConciergeStyle(item.conciergeStatus)}>
                {STATUS_MAP[item.conciergeStatus] || ''}
              </span>
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              <span style={getStatusStyle(item.status)}>{getStatusLabel(item.status)}</span>
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              {renderTraumaStatus(item.traumaStatus)}
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.status === 7 ? item.reasonForHold : ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.status === 0 ? item.reasonForReject : ''}</TableCell>
            <TableCell>
              {item.patientServiceEnquiryFormStatusLogList
                ? convertUTCToLocal(item.patientServiceEnquiryFormStatusLogList[0]?.statusDate)
                : ''}
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <FaEye onClick={() => onView(item)} style={{ cursor: 'pointer' }} />
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <FaEye onClick={() => onBillingView(item)} style={{ cursor: 'pointer' }} />
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, cursor: 'pointer' }}>
              <FaEye onClick={() => onEnquiryLog(item.id)} style={{ cursor: 'pointer' }} />
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, cursor: 'pointer' }}>
              {item.campLead === 0 ? 'No' : 'Yes'}
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, cursor: 'pointer' }}>{item.feedbackRate}</TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, cursor: 'pointer' }}>{item.feedbackNote}</TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, cursor: 'pointer' }}>{item.feedbackMsgStatus}</TableCell>
            {item.status === 6 && item.conciergeStatus === 4 ? (
              <TableCell
                style={{ fontSize: '15px', fontWeight: 900, width: '10%', cursor: 'pointer', color: '#18406E' }}
                onClick={() => onAddService(item)}
              >
                Add Service +
              </TableCell>
            ) : (
              <TableCell />
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

AllTabTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  roleCode: PropTypes.string,
  convertUTCToLocal: PropTypes.func.isRequired,
  getStatusStyle: PropTypes.func.isRequired,
  getStatusLabel: PropTypes.func.isRequired,
  getConciergeStyle: PropTypes.func.isRequired,
  renderTraumaStatus: PropTypes.func.isRequired,
  getBillingStyle: PropTypes.func.isRequired,
  getBillingStatusText: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onBillingView: PropTypes.func.isRequired,
  onEnquiryLog: PropTypes.func.isRequired,
  onAddService: PropTypes.func.isRequired,
};

AllTabTable.defaultProps = {
  roleCode: '',
};

export const NewTabTable = ({
  data,
  roleCode,
  convertUTCToLocal,
  getStatusStyle,
  getStatusLabel,
  getConciergeStatusText,
  renderTraumaStatus,
  onView,
  onAssignExecutive,
  onAssignBackOffice,
}) => (
  <TableContainer component={Paper} style={{ width: '100%', overflowX: 'auto' }}>
    <Table>
      <TableHead>
        <TableRow>
          {[
            'Enquiry ID', 'Patient ID', 'Patient Name', 'Enquiry Date',
            'Eclinic Name', 'Eclinic Location', 'Email Id', 'Swasthya Mithra',
            'Role', 'Mobile Number', 'Communication Number',
            'Preferred Hospital & eClinic', 'Concierge Name', 'Concierge Status',
            'Status', 'Trauma', 'Camp', 'Status Date', 'View Enquiry Details',
            'Executive', 'Backoffice',
          ].map((header) => (
            <TableCell key={header} style={HEADER_CELL_STYLE}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item) => (
          <TableRow key={item.id}>
            <TableCell style={BODY_CELL_STYLE_LG}>{item.id}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientId}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{convertUTCToLocal(item.createdDate)}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicLocationName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientEmail}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.swasthUserName || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.roleCode || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientContactNumber || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.communicationMobile || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.hospitalName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.conciergeName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{getConciergeStatusText(item.conciergeStatus)}</TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              <span style={getStatusStyle(item.status)}>{getStatusLabel(item.status)}</span>
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              {renderTraumaStatus(item.traumaStatus)}
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              {item.campLead === 0 ? 'No' : 'Yes'}
            </TableCell>
            <TableCell>
              {item.patientServiceEnquiryFormStatusLogList
                ? convertUTCToLocal(item.patientServiceEnquiryFormStatusLogList[0]?.statusDate)
                : ''}
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <FaEye onClick={() => onView(item)} style={{ cursor: 'pointer' }} />
            </TableCell>
            {roleCode !== ROLE_CODES.ACCADMIN && (
              <TableCell>
                <AssignButton label="Executive Assign" onClick={() => onAssignExecutive(item)} />
              </TableCell>
            )}
            {roleCode !== ROLE_CODES.ACCADMIN && roleCode !== ROLE_CODES.CE && (
              <TableCell>
                <AssignButton label="Back Office Assign" onClick={() => onAssignBackOffice(item)} />
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

NewTabTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  roleCode: PropTypes.string,
  convertUTCToLocal: PropTypes.func.isRequired,
  getStatusStyle: PropTypes.func.isRequired,
  getStatusLabel: PropTypes.func.isRequired,
  getConciergeStatusText: PropTypes.func.isRequired,
  renderTraumaStatus: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onAssignExecutive: PropTypes.func.isRequired,
  onAssignBackOffice: PropTypes.func.isRequired,
};

NewTabTable.defaultProps = {
  roleCode: '',
};

export const AssignTabTable = ({
  data,
  convertUTCToLocal,
  getStatusStyle,
  getStatusLabel,
  getConciergeStyle,
  renderTraumaStatus,
  onView,
  onBillingView,
  onAddService,
  onAssignExecutive,
  shouldShowAssignButton,
}) => (
  <TableContainer component={Paper} style={{ width: '100%', overflowX: 'auto' }}>
    <Table>
      <TableHead>
        <TableRow>
          {[
            'Enquiry ID', 'Patient ID', 'Patient Name', 'Enquiry Date',
            'Eclinic Name', 'Eclinic Location', 'Email Id', 'Swasthya Mithra',
            'Role', 'Mobile Number', 'Communication Number',
            'Preferred Hospital & eClinic', 'Concierge Name', 'Concierge Status',
            'Status', 'Trauma', 'Reason For Hold', 'Reason For Reject',
            'Status Date', 'View Enquiry Details', 'Billing Count',
            'Action', 'Camp', 'Executive',
          ].map((header) => (
            <TableCell key={header} style={HEADER_CELL_STYLE}>{header}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item) => (
          <TableRow key={item.id}>
            <TableCell style={BODY_CELL_STYLE_LG}>{item.id}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientId}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{convertUTCToLocal(item.createdDate)}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.eclinicLocationName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientEmail}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.swasthUserName || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.roleCode || 'NA'}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.patientContactNumber || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.communicationMobile || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.hospitalName}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.conciergeName || ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <span style={getConciergeStyle(item.conciergeStatus)}>
                {STATUS_MAP[item.conciergeStatus] || ''}
              </span>
            </TableCell>
            <TableCell style={{ ...BODY_CELL_STYLE, width: '200px' }}>
              <span style={getStatusStyle(item.status)}>{getStatusLabel(item.status)}</span>
            </TableCell>
            <TableCell>{renderTraumaStatus(item.traumaStatus)}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.status === 7 ? item.reasonForHold : ''}</TableCell>
            <TableCell style={BODY_CELL_STYLE}>{item.status === 0 ? item.reasonForReject : ''}</TableCell>
            <TableCell>
              {item.patientServiceEnquiryFormStatusLogList
                ? convertUTCToLocal(item.patientServiceEnquiryFormStatusLogList[0]?.statusDate)
                : ''}
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <FaEye onClick={() => onView(item)} style={{ cursor: 'pointer' }} />
            </TableCell>
            <TableCell style={BODY_CELL_STYLE}>
              <FaEye onClick={() => onBillingView(item)} style={{ cursor: 'pointer' }} />
            </TableCell>
            {item.status === 6 && item.conciergeStatus === 4 ? (
              <TableCell
                style={{ fontSize: '15px', fontWeight: 900, width: '10%', cursor: 'pointer', color: '#18406E' }}
                onClick={() => onAddService(item)}
              >
                Add Service +
              </TableCell>
            ) : (
              <TableCell />
            )}
            <TableCell style={BODY_CELL_STYLE}>{item.campLead === 0 ? 'No' : 'Yes'}</TableCell>
            {shouldShowAssignButton(item) && (
              <TableCell>
                <AssignButton label="Executive Assign" onClick={() => onAssignExecutive(item)} />
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

AssignTabTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  convertUTCToLocal: PropTypes.func.isRequired,
  getStatusStyle: PropTypes.func.isRequired,
  getStatusLabel: PropTypes.func.isRequired,
  getConciergeStyle: PropTypes.func.isRequired,
  renderTraumaStatus: PropTypes.func.isRequired,
  onView: PropTypes.func.isRequired,
  onBillingView: PropTypes.func.isRequired,
  onAddService: PropTypes.func.isRequired,
  onAssignExecutive: PropTypes.func.isRequired,
  shouldShowAssignButton: PropTypes.func.isRequired,
};